import React from 'react';

import ApplicationDetailsInterface from '@api/requests/applications/interfaces/ApplicationDetailsInterface.interface';

import { Button, CircularProgress, Typography } from '@mui/material';

import DownloadIcon from 'jsx:@assets/svgs/download.svg';

import { useDownloadApplicationPDF } from './hooks';

function DownloadApplicationButton({ application }: { application: ApplicationDetailsInterface }) {
	const { handleDownloadApplicationPDF, isApplicationPDFDownloading } = useDownloadApplicationPDF(application);

	return (
		<Button
			variant="contained"
			color="secondary"
			onClick={() => handleDownloadApplicationPDF()}
			disabled={isApplicationPDFDownloading}
			sx={{ textTransform: 'initial', width: 200, height: 32 }}
		>
			{isApplicationPDFDownloading ? (
				<CircularProgress size={15} color={'info'} variant={'indeterminate'} />
			) : (
				<React.Fragment>
					<DownloadIcon />

					<Typography variant={'caption'} ml={1}>
						<b>Download application</b>
					</Typography>
				</React.Fragment>
			)}
		</Button>
	);
}

export default DownloadApplicationButton;
